import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import NavItem from '../../components/NavItem';
import IconButton from '../../components/IconButton';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import { toast } from 'react-toastify';

export default function PainelProdutoGrupo() {
    const token = localStorage.getItem('token');
    const perfil = (localStorage.getItem('perfil') || '').trim().toLowerCase();
    const usuarioEhDiretor = ['admin', 'diretor'].includes(perfil);
    const [filtro, setFiltro] = useState([]);
    const [produtoGrupos, setProdutoGrupos] = useState([]);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setFiltro(prev => ({ ...prev, buscando: true }));
        api({
            method: 'get',
            action: '/produtoGrupo',
            token: token,
            params: filtro,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setProdutoGrupos(response.data.data);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                //console.log(err)
            })
    };

    const excluir = (id, nome) => {
        if (!usuarioEhDiretor) {
            return;
        }

        if (!window.confirm(`Deseja realmente excluir o grupo "${nome}"?`)) {
            return;
        }

        api({
            method: 'delete',
            action: '/produtoGrupo/' + id,
            token: token
        })
            .then(() => {
                toast.success('Grupo removido com sucesso');
                buscar();
            })
            .catch((error) => {
                toast.error(error?.response?.data?.error ?? 'Erro ao remover grupo');
            });
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroProdutoGrupo" icon={<FaPlus size={20} />} color="primary">Novo Grupo</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Grupos de Atributos</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Buscar pelo nome do serviço"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            persistTableHead
                                            progressComponent={<TabelaLoading />}
                                            noDataComponent={<TabelaVazia />}
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: row => (
                                                        <div className="d-flex gap-1">
                                                            <IconButton
                                                                small={true}
                                                                to={"/cadastroProdutoGrupo/" + row.id}
                                                                icon={<FaPen size={20} />}
                                                                color="primary">Alterar</IconButton>
                                                            {usuarioEhDiretor ? (
                                                                <IconButton
                                                                    small={true}
                                                                    onClick={() => excluir(row.id, row.nome ?? row.codigo ?? 'registro')}
                                                                    icon={<FaTrash size={16} />}
                                                                    color="warning">Excluir</IconButton>
                                                            ) : null}
                                                        </div>
                                                    ),
                                                    width: usuarioEhDiretor ? "220px" : "120px",
                                                },
                                                {
                                                    name: 'Código',
                                                    selector: row => row.codigo ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    right: true,
                                                },
                                                {
                                                    name: 'Nome',
                                                    selector: row => row.nome ?? "",
                                                    sortable: true,
                                                },
                                            ]}
                                            data={produtoGrupos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
